// src/pages/salaryPaymentReport/components/exportSalaryPaymentReportCsv.js
import dayjs from "dayjs";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum  = (val) => Number(val || 0).toFixed(2);
const fmtDate = (val) => (val ? dayjs(val).format("DD-MMM-YYYY") : "-");

/**
 * @param {object} params
 * @param {Array}   params.list     - from Redux state.salaryPaymentReport.list
 * @param {object}  params.filters  - filterType + recordType
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportSalaryPaymentReportCsv = ({
  list,
  filters,
  title    = "Salary Payment Report",
  filename = "salary_payment_report",
}) => {
  const { filterType, recordType } = filters;
  const isGrouped = recordType === "with details"
    || filterType === "By Employee"
    || filterType === "By Type";

  const rows = [[title], []];

  if (isGrouped) {
    // ── With Details / By Employee / By Type ─────────────────
    // Master row + indented child rows + sub-total spacer
    const headers = [
      "No.", "VCH No", "Date", "Payment From Account",
      "Month", "Payment By",
      // child sub-columns (offset right)
      "  Employee", "  Payment For", "  Amount",
    ].map(escape);

    rows.push(headers);

    let grandTotal = 0;

    list.forEach((row, i) => {
      grandTotal += Number(row.subtotal || 0);

      // Master row
      rows.push([
        i + 1,
        row.vch_no   || "",
        fmtDate(row.date),
        row.acc_name || "",
        row.month    || "",
        row.user     || "",
        "", "", "",
      ].map(escape));

      // Child rows
      (row.details || []).forEach((d) => {
        rows.push([
          "", "", "", "", "", "",
          d.employee || "",
          d.pay_type || "",
          fmtNum(d.amount),
        ].map(escape));
      });

      // Sub-total row
      rows.push([
        "", "", "", "", "",
        "Sub Total:", "", "", fmtNum(row.subtotal),
      ].map(escape));

      rows.push(Array(9).fill("").map(escape)); // blank spacer
    });

    rows.push([]); // spacer before grand total
    rows.push([
      "Grand Total:", "", "", "", "", "", "", "",
      fmtNum(grandTotal),
    ].map(escape));

  } else {
    // ── Without Details (flat) ────────────────────────────────
    const headers = [
      "No.", "VCH No", "Date", "Payment From Account",
      "Month", "Payment For", "Payment By", "Total Amount",
    ].map(escape);

    rows.push(headers);

    const grandTotal = list.reduce(
      (s, r) => s + Number(r.subtotal || r.total || 0), 0
    );

    list.forEach((row, i) => {
      rows.push([
        i + 1,
        row.vch_no   || "",
        fmtDate(row.date),
        row.acc_name || "",
        row.month    || "",
        row.pay_type || "",
        row.user     || "",
        fmtNum(row.subtotal || row.total),
      ].map(escape));
    });

    rows.push([]); // spacer
    rows.push([
      "Grand Total:", "", "", "", "", "", "",
      fmtNum(grandTotal),
    ].map(escape));
  }

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};